import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e0d524"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }

import NavMenu from "./components/header/NavMenu.vue";
import Footer from "./components/footer/FootContent.vue";
import SvgBackGround from "./components/header/SvgBackGround.vue";
import { ref, nextTick, provide } from "vue";
import { reloadFunction } from "@/functions/utils/CommonUtils";
import { reloadKey } from "@/functions/keys/index";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isRouterAlive = ref(true);

const route = useRoute();

const key = route.meta.activeMenuName as string;

const reload: reloadFunction = function () {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
};
provide(reloadKey, reload);

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(SvgBackGround)
    ]),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(NavMenu)
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          (isRouterAlive.value)
            ? (_openBlock(), _createBlock(_component_router_view, { key: _unref(key) }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(Footer)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})